import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";
import { getKycCrossProductProps } from "helper/kycDocumentUpload";
import { config } from "config";

const mapStateToProps = (state) => {
  return {
    currentStagePrime: state.jarvisPrime.primeOnboarding.currentStagePrime,
    loginProfile: state.customer.loginProfile,
    pan: state.jarvisPrime.primeOnboarding.pan,
    dateOfBirth: state.jarvisPrime.primeOnboarding.dateOfBirth,
    aadharNumber: state.jarvisPrime.primeOnboarding.aadharNumber,
    isPanUploaded: state.jarvisPrime.primeOnboarding.isPanUploaded,
    isAadhaarFrontUploaded:
      state.jarvisPrime.primeOnboarding.isAadhaarFrontUploaded,
    isAadhaarBackUploaded:
      state.jarvisPrime.primeOnboarding.isAadhaarBackUploaded,
    panVerification: state.jarvisPrime.primeOnboarding.panVerification,
    aadharFrontVerification:
      state.jarvisPrime.primeOnboarding.aadharFrontVerification,
    aadharBackVerification:
      state.jarvisPrime.primeOnboarding.aadharBackVerification,
    ...getKycCrossProductProps(state, config.productCodes.PRIME),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getOnboardingDataAction: jarvisPrimeOnboardingActions.getOnboardingData,
      updatePrimeOnboardingData:
        jarvisPrimeOnboardingActions.updatePrimeOnboardingData,
      setToast: commonActions.setToast,
    },
    dispatch
  );

const CKYCStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default CKYCStore;
